import { render, staticRenderFns } from "./q2.vue?vue&type=template&id=3dbb55cf&scoped=true&"
import script from "./q2.vue?vue&type=script&lang=js&"
export * from "./q2.vue?vue&type=script&lang=js&"
import style0 from "./q2.vue?vue&type=style&index=0&id=3dbb55cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbb55cf",
  null
  
)

export default component.exports